import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { siteConfig } from "../data/siteConfig";

const exploreLinks = [
  { label: "About Suman", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Pricing", to: "/pricing" },
  { label: "Gallery", to: "/gallery" },
];

const supportLinks = [
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
];

export const Footer = () => {
  return (
    <footer className="bg-charcoal text-cream pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-14">
          <div className="md:col-span-2">
            <RouterLink to="/" aria-label="Yogarambh Wellness home">
              <Logo light />
            </RouterLink>
            <p className="text-cream/70 max-w-sm leading-relaxed mt-6">
              Yoga with Suman Agrawal — creating harmony between body, mind and
              emotions through prenatal, kids, family, corporate and
              personalised yoga, online and in Hong Kong.
            </p>
          </div>

          <div>
            <h4 className="font-body text-white font-semibold uppercase tracking-widest text-xs mb-5">
              Explore
            </h4>
            <ul className="space-y-3 text-cream/70 text-sm">
              {exploreLinks.map((l) => (
                <li key={l.to}>
                  <RouterLink
                    to={l.to}
                    className="hover:text-white transition-colors"
                  >
                    {l.label}
                  </RouterLink>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-body text-white font-semibold uppercase tracking-widest text-xs mb-5">
              Get in touch
            </h4>
            <ul className="space-y-3 text-cream/70 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>{siteConfig.headquarters}</span>
              </li>
              <li>
                <a
                  href={`tel:+${siteConfig.phoneE164}`}
                  className="flex items-center gap-2 hover:text-white transition-colors"
                >
                  <Phone className="w-4 h-4 shrink-0" />
                  {siteConfig.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="flex items-center gap-2 hover:text-white transition-colors break-all"
                >
                  <Mail className="w-4 h-4 shrink-0" />
                  {siteConfig.email}
                </a>
              </li>
              {supportLinks.slice(1).map((l) => (
                <li key={l.to}>
                  <RouterLink
                    to={l.to}
                    className="hover:text-white transition-colors"
                  >
                    {l.label}
                  </RouterLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/15 pt-8 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-cream/60">
          <p>
            © {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <p>Made with care for the yoga community.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
